// BrushShape.tsx
import * as React from 'react';
import type { strokeDashTypes } from 'react-financial-charts';
import { getMouseCanvas, getStrokeDasharrayCanvas, GenericChartComponent } from 'react-financial-charts';

// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
const ChartComponent = GenericChartComponent as unknown as React.ComponentType<Record<string, unknown>>;

interface BrushShapeProps {
  rect: { x: number; y: number; width: number; height: number } | null;
  strokeStyle?: string;
  fillStyle?: string;
  strokeDashArray?: strokeDashTypes;
}

export const BrushShape: React.FC<BrushShapeProps> = ({ rect, strokeStyle, fillStyle, strokeDashArray = 'Solid' }) => {
  if (!rect) return null;
  const drawOnCanvas = (ctx: CanvasRenderingContext2D) => {
    const { x, y, height, width } = rect;

    const dashArray = getStrokeDasharrayCanvas(strokeDashArray);

    ctx.fillStyle = fillStyle!;
    ctx.fillRect(x, y, width, height);

    // Draw center lines
    const centerX = x + width / 2;
    const centerY = y + height / 2;

    ctx.strokeStyle = strokeStyle!;
    ctx.lineWidth = 1;
    ctx.setLineDash(dashArray);

    ctx.beginPath();
    ctx.moveTo(centerX, y);
    ctx.lineTo(centerX, y + height); // vertical line

    ctx.moveTo(x, centerY);
    ctx.lineTo(x + width, centerY); // horizontal line
    ctx.stroke();
  };

  return (
    <ChartComponent canvasToDraw={getMouseCanvas} canvasDraw={drawOnCanvas} drawOn={['mousemove', 'pan', 'drag']} />
  );
};
